import NotepadList from "./ListNote";

const NotePadApplication = () => {
  
  return (
    <NotepadList
    />
  );
};

export default NotePadApplication;